export default "__VITE_ASSET__CURZp5fr__"